<div class="image" *ngIf="type=='image'" [ngStyle]="{width: imgWidth, height: imgHeight}" [ngClass]="{roundImg: imgShape == 'round'}"></div>
<div class="text" *ngIf="type=='text'" [ngStyle]="{width: txtWidth, height: txtHeight}"></div>